const namespace = 'DATA/';

export const GET_CACHED_AVAIL_DATA = namespace + 'GET_CACHED_AVAIL_DATA';
